export default "__VITE_ASSET__DI$qj$nn__"